import css from "./index.module.css";
import Switch from "@mui/material/Switch";
import Button from "@mui/material/Button";
import Header from "../../../components/Header";
import Loading from "../../../components/Loading";
import avatar0 from "../../../assets/avatars/avatar0.jpeg"
import avatar1 from "../../../assets/avatars/avatar1.jpeg"
import avatar2 from "../../../assets/avatars/avatar2.jpeg"
import avatar3 from "../../../assets/avatars/avatar3.jpeg"
import avatar4 from "../../../assets/avatars/avatar4.jpeg"
import avatar5 from "../../../assets/avatars/avatar5.jpeg"
import avatar6 from "../../../assets/avatars/avatar6.jpeg"
import avatar7 from "../../../assets/avatars/avatar7.jpeg"
import avatar8 from "../../../assets/avatars/avatar8.jpeg"
import avatar9 from "../../../assets/avatars/avatar9.jpeg"
import avatar10 from "../../../assets/avatars/avatar10.jpeg"
import avatar11 from "../../../assets/avatars/avatar11.jpeg"
import avatar12 from "../../../assets/avatars/avatar12.jpeg"
import avatar13 from "../../../assets/avatars/avatar13.jpeg"
import avatar14 from "../../../assets/avatars/avatar14.jpeg"
import avatar15 from "../../../assets/avatars/avatar15.jpeg"
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';

import { useState, useEffect } from "react";
import { getDataById, updateData } from "../../../utils/fetch";

/**
 * displays settingspage where a student can alter avatar username and see its challengecode
 * @param {String} studentId 64 character uuid of given student 
 */
const Settings = ({ studentId }) => {
  const [student, setStudent] = useState(null);
  
  useEffect(() => {
    getDataById("/api/students/byId", { id: studentId }).then((data) => {
      setStudent(data);
    });
  }, [studentId]);

  return (
    <div className={css.page}>
      <Header isTeacher={false} nav="Einstellungen" />
      <div className={css.container}>
        {student == null && <Loading />}
        {student !== null && student.length === 0 && (
          <span>Kein Schüler gefunden</span>
        )}
        {student && (
          <div className={css.settings}>
            <Setting
              type="Spitzname"
              customData={student.nickname}
              checked={student.use_nickname}
              studentId={studentId}
              student={student}
              setStudent={setStudent}
            />
            <div className={css.placeholder}></div>
            <Setting
              type="Avatar"
              customData={student.avatar}
              checked={student.use_avatar}
              studentId={studentId}
              student={student}
              setStudent={setStudent}
            />
            <div className={css.placeholder}></div>
            <div className={css.setting}>
              <div className={css.switch}>
                <div className={css.text}>
                  <span></span>
                  <span>Challengecode</span>
                </div>
                <Switch disabled/>
              </div>
              <input disabled defaultValue={student?.challenge_code} name="customDataU"></input>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const Setting = ({ type, customData, checked, studentId, student, setStudent }) => {
  const [error, setError] = useState(false);

  const [useCustomData, setUseCustomData] = useState(checked);
  const [selectedAvatar, setSelectedAvatar] = useState(student.avatar);

  const avatars = [
    {name: "0", data: avatar0}, 
    {name: "1", data: avatar1}, 
    {name: "2", data: avatar2},
    {name: "3", data: avatar3},
    {name: "4", data: avatar4},
    {name: "5", data: avatar5}, 
    {name: "6", data: avatar6}, 
    {name: "7", data: avatar7}, 
    {name: "8", data: avatar8},
    {name: "9", data: avatar9},
    {name: "10", data: avatar10},
    {name: "11", data: avatar11},
    {name: "12", data: avatar12},
    {name: "13", data: avatar13},
    {name: "14", data: avatar14},
    {name: "15", data: avatar15},
  ]
 
  const handleSubmit = (e) => {
    e.preventDefault();
    const formdata = new FormData(e.target);
    const customDataU = formdata.get("customDataU");
    const useCustomDataU = formdata.get("useCustomDataU");

    if (customDataU === "" && useCustomDataU === "on") {
      setError(true);
      return
    }

    if(type === "Spitzname"){
      updateData("/api/students/nickname", {
        id: studentId,
        nickname: customDataU === null ? "" : customDataU, 
        use_nickname: useCustomDataU === "on" ? true : false
      }).then(() => {
        getDataById("/api/students/byId", { id: studentId }).then(data => setStudent(data));
      })
    } else {
      updateData("/api/students/avatar", {
        id: studentId,
        avatar: selectedAvatar === null ? "" : selectedAvatar, 
        use_avatar: useCustomDataU === "on" ? true : false
      })
    }
  }

  return (
    <form className={css.setting} onSubmit={handleSubmit}>
      <div className={css.switch}>
        <div className={css.text}>
          <span></span>
          <span>{type} anstatt {type === "Spitzname" ? "dem Standardnamen" : "der Buch- stabenkombination"} verwenden.</span>
        </div>
        <Switch
          onChange={() => setUseCustomData(!useCustomData)}
          defaultChecked={type === "Spitzname" ? student.use_nickname : student.use_avatar}
          name="useCustomDataU"
        />
      </div>
      <div className={css.switch}>
        <div className={css.texfielderror}>
        {useCustomData && type === "Spitzname" && <input defaultValue={customData} maxLength={20} min={5} name="customDataU"></input>}
        {!useCustomData && type === "Spitzname" && <input defaultValue={customData} disabled name="customDataU"></input>}
        {useCustomData && type === "Avatar" && (
          <div className={css.contentAvatar}>
            {avatars.map(e => {
              return (
                <img 
                  key={"avatarImg_" + e.name} 
                  src={e.data} 
                  onClick={() => setSelectedAvatar(e.name)}
                  className={e.name === selectedAvatar ? css.selected : ""}
                  alt={e.name}
                ></img>
              )
            })}
          </div>
        )}
        {error && <PriorityHighIcon style={{fill: "red", fontSize:"24px"}}/>}
        </div>
        <Button type="submit">Speichern</Button>
      </div>
    </form>
  );
};

export default Settings;
